const tailwindRuntimeConfig = {
  theme: {
    extend: {
      fontFamily: {
        sans: ["Nunito"],
      },
      fontWeight: {
        extreme: 900,
      },
      colors: {
        "zeos-black": "#000000",
        "zeos-blue": "#4053a3",
        "zeos-blue-lt": "#dbeafe",
        "zeos-green": "#2c9a47",
        "zeos-grey-dk": "#6f6b6b",
        "zeos-grey-lt": "#F2F2F2",
        "zeos-grey-md": "#9d9d9d",
        "zeos-white-md": "#f3f3f3",
        "zeos-orange-dk": "#f58921 !important",
        "zeos-orange-lt": "#ffbe74",
        "zeos-orange-md": "#ffa743",
        "zeos-red": "#ef5533",
        "zeos-white": "#ffffff",
        "zeos-yellow": "#faeda5",
        // Detail-dashboard mid-fi palette (4019); mirrors src/tailwind.config.js.
        mf: {
          bg: "#F3F4F6",
          card: "#FFFFFF",
          ink: "#25272E",
          sub: "#6B7280",
          faint: "#9AA1AC",
          border: "#E5E7EB",
          orange: "#F58220",
          "orange-soft": "#FEF0E2",
          "orange-ink": "#B25E0B",
          energy: "#2FBF71",
          "energy-md": "#8ED9B0",
          "energy-soft": "#E7F7EE",
          "energy-ink": "#1E8A52",
          slate: "#5B6478",
          "slate-soft": "#E9EBF0",
          alert: "#D9534F",
          "alert-soft": "#FBEAE9",
          future: "#F1F2F4",
        },
      },
      boxShadow: {
        "mf-card": "0 1px 2px rgba(16,24,40,.04)",
        "mf-pop": "0 10px 24px rgba(16,24,40,.12)",
      },
    },
  },
  plugins: [],
};

export default tailwindRuntimeConfig;
export { tailwindRuntimeConfig };
